// extracted by mini-css-extract-plugin
export default {"week-days-chart":"WeekDaysSalesAmountChart_week-days-chart__gxh6m","action":"WeekDaysSalesAmountChart_action__UUPdQ"};